<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-if="dialogShow"
    v-model="dialogShow"
    class="items-no-padding outcommission-dialog sidebar-dialog">
    <div class="sidebar-content h-full">

      <div class="customizer-header items-center px-6 sliderbar-header-big">
        <div class="title">
          <div class="text">
            {{title}}
          </div>
          <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
        </div>
        <div class="subtitle">
          <span
            class="step-text"
            :class="{'theme-color': step == 1}"
          >{{$t('Select_channel')}}</span>
          <i class="el-icon-arrow-right i-arrow"></i>
          <span
            class="step-text"
            :class="{'theme-color': step == 2}"
          >{{$t('User.applyCommi')}}</span>
        </div>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <first-step
            v-show="step == 1"
            ref="firststep"
            :descs="outToMt4.descs"
            @card-click="cardClick"
          ></first-step>
          <second-step-self-account
            ref="selfaccount"
            :descs="outToMt4.descs"
            :remain-amount="remainAmount"
            v-show="step == 2 && type == 1"
            @validate-form-flag="validateFormFlag"
          ></second-step-self-account>
          <second-step-to-channel
            ref="tochannel"
            :remain-amount="remainAmount"
            :current-withdraw-info="currentWithdrawInfo"
            v-show="step == 2 && type == 2"
            @validate-form-flag="validateChannelFormFlag"
            @add-collection="addCollection"
          ></second-step-to-channel>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        v-if="step == 2"
        @click="prevHandle"
        type="text"
        class="calcel-btn"
      >{{$t('root.upper')}}</el-button>
      <el-button
        v-if="step == 1"
        @click="nextHandle"
        type="primary"
        class="calcel-btn"
        :loading="isload"
      >{{$t('root.next')}}</el-button>
      <el-button
        v-if="step == 2"
        :loading="submitLoading"
        @click="submitHandle"
        type="primary"
      >{{$t('confirm')}}</el-button>
    </div>
  </vs-sidebar>
</template>

<script>
import secondStepToChannel from "@/components/agent/secondStepToChannel";
import secondStepSelfAccount from "@/components/agent/secondStepSelfAccount";
import firstStep from '@/components/agent/firstStep'
import { getDictListByType } from '@/api/home.js';
import { mapGetters } from 'vuex';
import { isMobile } from '@/utils/validate';
import { getAddPhoneVer, addPhoneSubmit,CommiApply,getUSDExRateAndFee } from '@/api/userCenter.js';

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "outCommissionDialog",
  components:{
    VuePerfectScrollbar,
    firstStep,
    secondStepSelfAccount,
    secondStepToChannel,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    remainAmount: {
    }
  },
  data() {
    let _this = this;
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('Commission'),
      step: 1,
      type: 1, // 1为自转, 2.为出佣
      submitLoading: false,
      currentWithdrawInfo: {},
      outMoney: {
        realExRateWithdraw:1,
        nominalExRateWithdraw:1
      },
      isload:false
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    outToMt4(){
      return {
        descs: [
          `1.${this.$t('Unlimited_amount')}。`,
          `2.${this.$t('No_handling_fee_is_charged_funds_are_withdrawn_to_your_own_MT4_account')}`,
        ]
      }
    },
  },
  created(){
    //this.getRate();
  },
  methods: {
    // getRate() {
    //   let parmas = {
    //     oprType: 2,
    //   };
    //   getUSDExRateAndFee(parmas).then((res) => {
    //     this.outMoney = res.data[0] ? res.data[0] : {};
    //   });
    // },
    prevHandle(){
      this.step = 1;
      this.type = 1;

    },
    cardClick(currentWithdrawInfo){
      this.currentWithdrawInfo = currentWithdrawInfo;
    },
    reset(){
      this.$refs.firststep.curIndex = -1;
      this.step = 1;
      this.type = 1;
      let selfaccount = this.$refs.selfaccount
      selfaccount.$refs.form.resetFields();
      let tochannel = this.$refs.tochannel;
      tochannel.$refs.form.resetFields();
    },

    executefunc(){
      this.isload = false;
      this.step = 2;
    },
    nextHandle(){
      if(this.$refs.firststep.curIndex > -1){
        // 选择了出金渠道
        this.type = 2;
      }else {
        this.type = 1;
      }
      if(this.type == 2 &&this.$refs.firststep.curIndex == 1){
        this.isload = true;
        this.$refs.tochannel.getWithdrawInfo(this.executefunc);
      }else{
        this.step = 2;
      }
    },
    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
      this.reset();
    },
    phFileter(data){
      return this.$t(data);
    },
    stepHandle(step){
      this.step = step;
    },

    submitHandle(){
      if(this.$refs.firststep.curIndex == -1){
        // 转自持账户
        this.$refs.selfaccount.validate();
      }else {
        // 出佣到本地汇款/数字货币/otc
        this.$refs.tochannel.validate();
      }
    },
    // 自持表单validate
    validateFormFlag(form,tocurLogin){

      let parmas = {
        merchantId: this.userInfo.id,
        amount: form.amount,
        phoneVerCode: null,
        mt4Account : tocurLogin,
      }
      let ccc = form.amount * this.outMoney.nominalExRateWithdraw;
      let transCurrency = ccc.toFixed(2);
      parmas['type'] = 2;
      parmas['currency'] = 'USD';
      parmas['billAmount'] = transCurrency;
      parmas['realExRate'] = this.outMoney.realExRateWithdraw;
      parmas['nominalExRate'] = this.outMoney.nominalExRateWithdraw;
      //如果不是银行卡的话汇率都是1
      if(this.currentWithdrawInfo.payTypeId != 7){
        parmas['realExRate'] = 1;
        parmas['nominalExRate'] = 1;
      }
      this.submitLoading = true;
      CommiApply(parmas).then((res) => {
        this.submitLoading = false;
        if(res.status===10000) {
          this.reset();
          this.$message({
            type: 'success',
            message: this.$t('Partner.commitSuccess')
          })

          this.$emit('outCommission-success');
          setTimeout(() => {
            this.close();
          },500);
        }
      }).catch((res) => {
        this.submitLoading = false;
      })
    },
    validateChannelFormFlag(form){
      let parmas = {
        merchantId: this.userInfo.id,
        amount: form.amount,
        phoneVerCode: null,
        payTypeId: this.currentWithdrawInfo.payTypeId,
      }
      let ccc = form.amount * this.outMoney.nominalExRateWithdraw;
      let transCurrency = ccc.toFixed(2);
      parmas['type'] = 1;
      parmas['currency'] = form.currency?form.currency:'USD';
      parmas['billAmount'] = form.billAmount?form.billAmount:transCurrency;
      parmas['realExRate'] = form.outMoney.realExRateWithdraw?form.outMoney.realExRateWithdraw:this.outMoney.realExRateWithdraw;
      parmas['nominalExRate'] = form.outMoney.nominalExRateWithdraw?form.outMoney.nominalExRateWithdraw:this.outMoney.nominalExRateWithdraw;
       //如果不是银行卡的话汇率都是1
      if(this.currentWithdrawInfo.payTypeId != 7){
        parmas['realExRate'] = 1;
        parmas['nominalExRate'] = 1;
      }
      CommiApply(parmas).then((res) => {
        if(res.status===10000) {
          this.reset();
          this.$message({
            type: 'success',
            message: this.$t('Partner.commitSuccess')
          })

          this.$emit('outCommission-success')
          setTimeout(() => {
            this.close();
          },500);
        }
      }).catch((error) => {
        this.loading = false;
      })
    },
    cancelHandle(){
      this.close();
    },

    addCollection(channelType){
      this.$emit('add-collection',channelType);
    }
  },
}
</script>
<style lang="scss" scoped>
@import "../../assets/scss/variable";
.outcommission-dialog {
  //
  .sliderbar-header-big {
    background-color: #F8F8F8;
    padding-bottom: 10px;
    .title {
      height: 46px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .text {
        font-weight: 600;
        font-size: 16px;
      }
    }
    .i-arrow {
      padding: 0 10px;
    }
    .subtitle {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .step-text {
        //cursor: pointer;
      }
    }
  }
  .content {
    .text-box {
      background-color: #F8F8F8;
      padding: 10px;
      border-radius: 6px;
      .text-box-line {
        margin-bottom: 10px;
        font-size: 14px;
        .text-left {
          color: #A29FAE;
        }
        .data-right {
          color: #6E6B7B;
        }
      }
    }
    .elform {
      margin-top: 30px;
    }
    .code-box {
      position: relative;
      .sendMes {
        line-height: 14px;
        position: absolute;
        bottom: 13px;
        right: 20px;
        text-align: right;
        color: $themeColor;
        span {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.outcommission-dialog {
  .vs-sidebar--items {

  }
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 20px;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
